import $ from 'jquery'

// Get and show location
// ---------------------------------------------------------------------

const DESIRED_ACCURACY = 10 // meters
const MAXIMUM_WAIT = 15000 // milliseconds

// The device's position: the first fix within DESIRED_ACCURACY, else the
// most accurate one it reports within MAXIMUM_WAIT. A phone's first fixes
// are often coarse, from cell towers and Wi-Fi, and sharpen as GPS comes in.
const locate = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error('Geolocation is not supported'))
    return
  }

  let bestPosition
  const finish = (error) => {
    navigator.geolocation.clearWatch(watchId)
    clearTimeout(timer)
    if (bestPosition) resolve(bestPosition)
    else reject(error)
  }
  const watchId = navigator.geolocation.watchPosition((position) => {
    if (!bestPosition || position.coords.accuracy < bestPosition.coords.accuracy) bestPosition = position
    if (position.coords.accuracy <= DESIRED_ACCURACY) finish()
  }, finish, { enableHighAccuracy: true, maximumAge: 0, timeout: MAXIMUM_WAIT })
  const timer = setTimeout(() => finish(new Error('No position')), MAXIMUM_WAIT)
})

const getLocation = async function() {
  onGeoTracking()

  let position
  try {
    position = await locate()
  } catch {
    onGeoError()
    return
  }
  onGeoSuccess(position)
}

// The address at the given coordinates, or '' when there is none. Saved
// without one, the time tracking gets it looked up on the server later.
const lookUpAddress = async function(latitude, longitude) {
  const url = new URL(document.querySelector('[data-address-url]').dataset.addressUrl, window.location.origin)
  url.search = new URLSearchParams({ latitude, longitude })
  try {
    const response = await fetch(url, { headers: { Accept: 'application/json' } })
    if (!response.ok) return ''
    const { address } = await response.json()
    return address || ''
  } catch {
    return ''
  }
}

// Function that gets run when position was found
const onGeoSuccess = async function(position) {
  const { latitude, longitude } = position.coords
  // Populate form values
  $('#time_tracking_latitude').val(latitude)
  $('#time_tracking_longitude').val(longitude)
  // Show confirmation
  $('#time_tracking_location_false').hide()
  $('#time_tracking_location_progress').hide()
  // Update static map (light + dark; CSS picks the one that matches the theme)
  const mapboxToken = 'pk.eyJ1IjoidzN3ZXJrZSIsImEiOiIwM0s5MkRjIn0.VMPxOOW9BwuFMHilUc7sSg'
  const staticMapUrl = (style) =>
    `https://api.mapbox.com/styles/v1/${style}/static/pin-s+27b6af(${longitude},${latitude})/${longitude},${latitude},15/430x270@2x?access_token=${mapboxToken}&logo=false`
  $('#map img.map-theme-light').attr('src', staticMapUrl('mapbox/light-v10'))
  $('#map img.map-theme-dark').attr('src', staticMapUrl('mapbox/dark-v10'))
  // Show tracked address
  $('#time_tracking_current_location').show()
  $('#map').show()
  const address = await lookUpAddress(latitude, longitude)
  // Removed while the address was on its way: it stays removed
  if ($('#time_tracking_latitude').val() !== String(latitude)) return
  $('#time_tracking_address').val(address)
  $('#time_tracking_current_location .output').text(address)
}

// Function that gets run when position was not found. The time tracking is
// then saved without a location: 0, 0 would count as one and get geocoded.
const onGeoError = function() {
  $('#time_tracking_latitude').val('')
  $('#time_tracking_longitude').val('')
  $('#time_tracking_address').val('')
  $('#time_tracking_location_progress').hide()
  $('#time_tracking_location_false').css('display', 'block')
}

// Function that gets run while position finding is in progress
const onGeoTracking = function() {
  $('#time_tracking_location_false').hide()
  $('#time_tracking_location_progress').css('display', 'block')
}

// Location finder gets activated on last TimeTracking creation form step
$(function() {
  if ($('body.timetrackings.build .end').length > 0) {
    getLocation()
  }
})

// Button/link to re-run location tracking
$(() => {
  $('.rerun_get_location').on('click', function(event) {
    event.preventDefault()
    window.location.reload(false)
  })
})

// Button/link to remove location
$(() => {
  $('.destroy_location').on('click', function(event) {
    event.preventDefault()
    $('#time_tracking_location').hide()
    $('#time_tracking_latitude').val('')
    $('#time_tracking_longitude').val('')
    $('#time_tracking_address').val('')
    $('#time_tracking_current_location').hide()
    $('#time_tracking_no_location_submitted').show()
    $('#map').hide()
  })
})

// Elapsed time counter
// ---------------------------------------------------------------------
//
// Browsers throttle setInterval in background tabs, so incrementing the
// displayed HH:MM:SS drifts. Keep a wall-clock baseline (the instant elapsed
// time was 00:00:00) and format Date.now() - baseline on every tick.
//
// Recalculating via `new Date(0, 0, 0, h, m, s)` plus getHours() produced
// NaN:NaN:NaN after a tab had been in the background: whitespace in the
// timer text, an already-invalid display, or an Invalid Date from that
// constructor all poison the next focus handler run.

let countInterval = null
let timerStartedAt = null

const TIMER_TEXT_PATTERN = /^(\d+):([0-5]?\d):([0-5]?\d)$/

const zeroPad = function(digit) {
  const numeric = Number(digit)
  if (!Number.isFinite(numeric) || numeric < 0) {
    return '00'
  }
  const whole = Math.floor(numeric)
  return whole < 10 ? `0${whole}` : String(whole)
}

const parseTimerText = function(text) {
  const match = String(text || '').trim().match(TIMER_TEXT_PATTERN)
  if (!match) { return null }
  return (Number(match[1]) * 3600) + (Number(match[2]) * 60) + Number(match[3])
}

const formatTimer = function(totalSeconds) {
  let seconds = totalSeconds
  if (!Number.isFinite(seconds) || seconds < 0) {
    seconds = 0
  }
  seconds = Math.floor(seconds)
  const hour = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60
  return `${zeroPad(hour)}:${zeroPad(mins)}:${zeroPad(secs)}`
}

const syncTimer = function() {
  if (timerStartedAt == null) { return }
  if ($('#time_tracking_timer').length === 0) { return }
  const elapsedSeconds = (Date.now() - timerStartedAt) / 1000
  $('#time_tracking_timer').text(formatTimer(elapsedSeconds))
}

const startCount = function() {
  if (countInterval) { return } // Make sure only one counter is ever running
  countInterval = setInterval(syncTimer, 1000)
}

const stopCount = function() {
  clearInterval(countInterval)
  countInterval = null
}

// Turbo keeps the JavaScript context across navigations and only fires
// window.onload for the very first document, so hook the counter up to every
// rendered page instead.
const bindElapsedTimer = function() {
  const $timer = $('#time_tracking_timer')
  if ($timer.length === 0) {
    stopCount()
    timerStartedAt = null
    return
  }

  const elapsedSeconds = parseTimerText($timer.text())
  if (elapsedSeconds != null) {
    timerStartedAt = Date.now() - (elapsedSeconds * 1000)
  } else if (timerStartedAt == null) {
    return
  }

  syncTimer()
  startCount()
}

$(document).on('turbo:load turbo:render', bindElapsedTimer)

// Recalculate when the tab or app becomes visible again (unlocking a phone,
// switching back to the CGX tab, or restoring from the back/forward cache).
const resyncTimerIfPresent = function() {
  if (document.visibilityState && document.visibilityState !== 'visible') {
    return
  }
  syncTimer()
}

$(window).on('focus pageshow', resyncTimerIfPresent)
$(document).on('visibilitychange', resyncTimerIfPresent)

// Set dropdowns for first page of new TimeTracking
// ---------------------------------------------------------------------

$(function() {
  const selectEstate = $('#time_tracking_estate_id')

  // Preselect primary fields, if they contain only one option and nothing is selected already
  if ((selectEstate.find('option').length <= 2) && (selectEstate.find('option:selected').val() === '')) {
    const firstValue = selectEstate.find('option:nth-child(2)').val()
    selectEstate.val(firstValue)
    selectEstate.trigger('change')
  }
})
